export default __webpack_public_path__ + "static/media/offering3.c9b44d48.png";